import { ApolloClient, ApolloLink, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { toast } from 'react-toastify';
import { parseGraphqlErrors } from 'shared-ui/lib/utils/get-gql-error';
import { GraphQLError } from 'graphql';

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(({ message, locations, path }) => {
      const error = `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`;
      toast.error(parseGraphqlErrors(graphQLErrors as GraphQLError[]));
      // eslint-disable-next-line no-console
      console.log(error);
      if (parseGraphqlErrors(graphQLErrors as GraphQLError[]) == 'Forbidden resource') {
        localStorage.removeItem('admin-token');
        window.location.reload();
      }
      if (parseGraphqlErrors(graphQLErrors as GraphQLError[]) == 'Unauthorized') {
        localStorage.removeItem('admin-token');
        window.location.reload();
      }
    });
  if (networkError) {
    const error = `[Network error]: ${networkError}`;
    // eslint-disable-next-line no-console
    console.log(error);
  }
});

const host = process.env.REACT_APP_API_URL;

const uri = `${host}/graphql`;

const httpLink = createHttpLink({
  uri,
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('admin-token');
  return {
    headers: {
      ...headers,
      'admin-authorization': token ? `${token}` : '',
    },
  };
});

const apolloClient = new ApolloClient({
  link: ApolloLink.from([errorLink as ApolloLink, authLink, httpLink]),
  cache: new InMemoryCache(),
  defaultOptions: {
    mutate: {
      errorPolicy: 'all',
    },
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  },
});

export default apolloClient;
